import { render, staticRenderFns } from "./SalesPointsList.vue?vue&type=template&id=f31b823e&scoped=true&"
import script from "./SalesPointsList.vue?vue&type=script&lang=js&"
export * from "./SalesPointsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31b823e",
  null
  
)

export default component.exports